import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        // 対象のクラスを増やす
        const targetClasses = [
            "fadeInUp", 
            "fadeInLeft", 
            "fadeInRight"
        ];
        const selector = targetClasses.map(cls => `.${cls}`).join(",");
        const elements = document.querySelectorAll(selector);

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on");
                    }
                });
            },
            { threshold: 0.1 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }
};


// export const onRouteUpdate = () => {
//     if (typeof document !== "undefined") {
//         const elements = document.querySelectorAll(".fadeInUp");

//         const observer = new IntersectionObserver(
//             (entries) => {
//                 entries.forEach((entry) => {
//                     if (entry.isIntersecting) {
//                         entry.target.classList.add("on");
//                     }
//                 });
//             },
//             { threshold: 0.1 }
//         );

//         elements.forEach((el) => observer.observe(el));

//         return () => {
//             elements.forEach((el) => observer.unobserve(el));
//         };
//     };
    
// };


